import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NoteMaterial.html?raw';
import lang from 'dojo/_base/lang';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import "../../moreCore/UI/StaticTable/StaticTable";

class NoteMaterial extends compose(_WidgetBaseSP) {
    templateString: any = template;

    listContainer: HTMLDivElement;
    resultTable: MdsLax<InstanceType<typeof StaticTable>>;
    tableLayout: StaticTable.Layout = {
        "name": "default",
        "label": "Default",
        rows: [{
            attributes: ["gDisp_1", "ref_note_type.description"],
            colNamesInternal: ["note", "type"],
            headings: ["Notenmaterial", "Typ"],
            widths: ["80%", "20%"],
            colspans: [1, 1],

        }
        ]
    };

    createNoteTable(programs) {

        this.resultTable = new StaticTable();
        this.resultTable.setTableLayout(this.tableLayout);

        this.resultTable.setGroupingEnabled(true);
        this.resultTable.setGroupingParameter("program")
        this.resultTable.setData(programs)
        this.resultTable.setCyAttribute("NoteMaterialResultTable");
        this.UiModder.domConstruct.place(this.resultTable.domNode, this.listContainer, "first");



        /*
        let table = this.UiModder.domConstruct.create("table", {}, this.listContainer)

        for (let program of programs) {

            let tr = this.UiModder.domConstruct.create("tr", {}, table)
            this.UiModder.domConstruct.create("td", { innerHTML: program.program + " (" + program.author + ")" }, tr)
            this.UiModder.domConstruct.create("td", { innerHTML: program.gDisp_1}, tr)
            this.UiModder.domConstruct.create("td", { innerHTML: program.ref_note_type.description}, tr)
        }
        */

    }

    getNoteMaterial(programmIds?, functionId?) {
        let url = window.appRoot + "NoteMaterial/GetNoteMaterial";
        let data = {
            programIds: programmIds,
            functionId: functionId
        };

        this.StandbyStart();
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onGetNoteMaterialResponse),
            lang.hitch(this, this._onGetNoteMaterialError),
            false // sync
        );
    }

    _onGetNoteMaterialResponse(response) {
        this.createNoteTable(response)
        this.StandbyStop();
    }

    _onGetNoteMaterialError(err: more.requestErrorMessage) {
        alert("ERROR beim SaveDashboardWidgets: " + err.Message);

    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NoteMaterial);